import React from 'react';
import PropTypes from 'prop-types';
import {useCSContext} from 'Context/ContentStackContext';

// Usable directly as an antd Input's `suffix`/`prefix` (unlike MUI's InputAdornment,
// antd doesn't need a special positioning wrapper around the icon).
const ClearInputIcon = ({reset}) => {
  const {artifacts} = useCSContext();

  return (
    <img
      src={artifacts.gray_close}
      alt="Clear input"
      onClick={() => reset()}
      style={{cursor: 'pointer', width: 16, height: 16}}
    />
  );
};

ClearInputIcon.propTypes = {
  reset: PropTypes.func.isRequired,
};

export default ClearInputIcon;
